/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { ContentZoneContext } from "cms/components/context/index";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isGuid } from "utils/empty-exists";
import { useAuth } from "cms/auth/hooks/use-auth";

const ComponentReuseBanner = () => {
    // Also see src/cms/components/layout/reuse/reused-icon/component-reuse-icon.jsx
    const { t } = useTranslation();
    const { token } = useAuth();
    const theme = useTheme();
    const { component, setComponentReuseDialogOpen } = useContext(ContentZoneContext);
    const guid = component?.guid;
    const reuse_count = component?.reuse_count ?? 0;
    
    /*
         TODO:
             eventually remove this look up.
             reuse_count can be pre-populated to provide usage without a lookup (until you click for more info)
             but having this query here for now fixes cases where the data is not up to date yet
             reuse_count is populated when components are saved.
     */
    const [usageCount, setUsageCount] = useState(reuse_count);
    useEffect(() => {
        const fetchUsage = async () => {
            if (isGuid(guid)) {
                let _usage = await SimpliCityAdminSDK.component.getComponentUsage(token, guid);
                if (_usage) {
                    setUsageCount(_usage?.length);
                }
            }
        };
        fetchUsage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);
    
    const onClickLink = (event) => {
        event.stopPropagation();
        setComponentReuseDialogOpen(true);
    };

    return (
        <>
            {usageCount > 1 &&
                <div
                    className='component-reuse-banner'
                    style={{
                        paddingTop: "1em",
                        paddingBottom: "1em",
                        borderBottom: "1px solid #cecece",
                        padding: "8px 1em",
                        fontSize: "12px",
                    }}
                >
                    <span>{`This component is used ${usageCount} times. `}</span>
                    <span>
                        <a href="#" onClick={onClickLink}>
                            {t("commons.viewDetails")}
                        </a>
                    </span>
                </div>
            }
        </>
    );
};
export { ComponentReuseBanner };
